<template>

    <div>

        <h1 class="mt-4">Abonnemang <button class="btn btn-primary btn-sm ms-4" @click="createSubscription()">Lägg till abonnemang
                        <div class="tooltip-label">Lägg till ett nytt abonnemang.</div>
                    </button></h1>

        <div class="content-container">

            <div class="row mb-4">

                <div class="col-24 col-md-6">
                    <input type="text"
                           class="form-control new-list-group-field"
                           placeholder="Sök abonnemang"
                           v-model="settings.query.text"
                    >
                </div>

                <div class="col-24 col-md-5">
                    <select class="form-select new-list-group-field"  v-model="settings.query.type">
                        <option :value="null">Abonnemangsform</option>
                        <option value="binding_period">Fast abonnemangsperiod</option>
                        <option value="dynamic_period">Löpande abonnemang med uppsägningstid</option>
                        <option value="pay_per_treatment">Betala per behandling</option>
                        <option value="unlimited">Löpande abonnemang utan pott</option>
                    </select>
                </div>

                <div class="col-12 col-md-3">
                    <div class="form-check pt-2">
                        <input class="form-check-input" type="checkbox" id="filter-clinic" v-model="settings.query.internal">
                        <label class="form-check-label" for="filter-clinic">
                            På mottagning
                        </label>
                    </div>
                </div>

                <div class="col-12 col-md-5">
                    <div class="form-check pt-2">
                        <input class="form-check-input" type="checkbox" value="" id="filter-on-location"  v-model="settings.query.external">
                        <label class="form-check-label" for="filter-on-location">
                            På arbetsplatsen
                        </label>
                    </div>
                </div>

            </div>

            <list ref="list" :settings="settings" :query.sync="settings.query">
                <div slot="item-row" slot-scope="props">
                    <div class="row g-3">
                        <div class="col d-none d-md-flex col-md-1">
                            <span>{{ props.item.id }}</span>
                        </div>
                        <div class="col col-9 col-md-4">
                            <span v-if="props.item.name">{{ props.item.name }}</span>
                            <span v-else><i>Nytt abonnemang</i></span>
                        </div>
                        <div class="col col-9 col-md-4">
                            <span>{{ props.item.name_public }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-4">
                            <span>{{ props.item.nice.name }}</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span v-if="props.item.type !== 'pay_per_treatment'">
                                {{ props.item.monthly_cost }}
                            </span>
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span v-if="props.item.duration_id == 1">25 min</span>
                            <span v-if="props.item.duration_id == 2">40 min</span>
                            <span v-if="props.item.duration_id == 3">50 min</span>
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span class="fa fa-check" v-if="props.item.internal"></span>
                        </div>
                        <div class="col d-none d-md-flex col-md-2">
                            <span class="fa fa-check" v-if="props.item.external"></span>
                        </div>
                        <div class="col col-6 col-md-3 d-flex justify-content-end">
                            <a :href="'/subscriptions/'+props.item.id">
                                <button class="btn btn-primary btn-sm me-2">Hantera
                                    <div class="tooltip-label">Redigera och hantera abonnemanget</div>
                                </button>
                            </a>
                            <button class="btn btn-danger btn-sm" v-if="props.item.count_contracts === 0" :disabled="deleter.submitted" @click="triggerDelete(props.item.id)">
                                <img src="/images/admin/icon-trash.svg">
                                <div class="tooltip-label">Du kan radera abonnemanget fram till att det används av minst en kund.</div>
                            </button>
                            <button class="btn btn-info btn-sm inactive" v-else>
                                <img src="/images/admin/icon-trash.svg">
                                <div class="tooltip-label">Abonnemanget har börjat användas av minst en kund, och kan därför inte tas bort.</div>
                            </button>
                        </div>
                    </div>
                </div>
            </list>

        </div>

    </div>

</template>

<script>
import axios from 'axios'

import lister from '../../../../shared/mixins/lister'
import deleter from '../../../../shared/mixins/deleter'

export default {

    mixins: [
        lister,
        deleter
    ],

    data () {
        return {
            modal_employee_id: null,

            settings: {
                url: '/subscriptions/list',
                query: {
                    text: '',
                    type: null,
                    internal: false,
                    external: false
                },
                columns: [
                    { column: 'id', name: 'ID', class: 'col d-none d-md-flex col-md-1', sortable: true, default: true },
                    { column: 'name', name: 'Arbetsnamn', class: 'col col-9 col-md-4', sortable: true },
                    { column: 'name_public', name: 'Namn för kunder', class: 'col col-9 col-md-4', sortable: true },
                    { column: 'type', name: 'Abonnemangsform', class: 'col d-none d-md-flex col-md-4', sortable: true },
                    { column: 'monthly_cost', name: 'Månadspris', class: 'col d-none d-md-flex col-md-2', sortable: true },
                    { column: 'duration_id', name: 'Längd', class: 'col d-none d-md-flex col-md-2', sortable: true },
                    { column: 'internal', name: 'Mottagning', class: 'col d-none d-md-flex col-md-2', sortable: true },
                    { column: 'external', name: 'Arbetsplats', class: 'col d-none d-md-flex col-md-2', sortable: true }
                ],
                bulk_actions: []
            }
        }
    },

    computed: {
        deleterUrl () {
            return '/subscriptions'
        }
    },

    methods: {
        createSubscription () {
            axios.post('/subscriptions')
                .then(response => {
                    window.location.href = '/subscriptions/' + response.data.subscription_id
                })
        },

        triggerDelete (subscription_id) {
            if (!confirm('Vill du verkligen radera abonnemanget?')) {
                return
            }
            this.deleterDelete(subscription_id)
        },

        deleterSuccess () {
            bus.$emit(
                'notify',
                'Abonnemanget har raderats'
            )
            this.refresh()
        }
    }
}
</script>
